export const GET_ALLOYPCDS_STATED = 'GET_ALLOYPCDS_STATED';
export const GET_ALLOYPCDS = 'GET_ALLOYPCDS';
export const GET_ALLOYPCDS_ENDED = 'GET_ALLOYPCDS_ENDED';

export const ADD_ALLOYPCD_STATED = 'ADD_ALLOYPCD_STATED';
export const ADD_ALLOYPCD = 'ADD_ALLOYPCD';
export const ADD_ALLOYPCD_ENDED = 'ADD_ALLOYPCD_ENDED';

export const EDIT_ALLOYPCD_STATED = 'EDIT_ALLOYPCD_STATED';
export const EDIT_ALLOYPCD = 'EDIT_ALLOYPCD';
export const EDIT_ALLOYPCD_ENDED = 'EDIT_ALLOYPCD_ENDED';

export const GET_ALLOYPCD_STATED = 'GET_ALLOYPCD_STATED';
export const GET_ALLOYPCD = 'GET_ALLOYPCD';
export const GET_ALLOYPCD_ENDED = 'GET_ALLOYPCD_ENDED';

export const GET_ALL_ALLOYPCDS_STATED = 'GET_ALL_ALLOYPCDS_STATED';
export const GET_ALL_ALLOYPCDS = 'GET_ALL_ALLOYPCDS';
export const GET_ALL_ALLOYPCDS_ENDED = 'GET_ALL_ALLOYPCDS_ENDED';
